import styled from 'react-emotion';
import {
  space,
  width,
  maxWidth,
  flex,
  order,
  alignSelf,
  position,
  background,
  textAlign,
  height,
  borderRadius,
} from 'styled-system';

const Box = styled('div')`
  box-sizing: border-box;
  ${space}
  ${width}
  ${order}
  ${alignSelf}
  ${position}
  ${background}
  ${textAlign}
  ${maxWidth}
  ${height}
  ${borderRadius}
`


Box.propTypes = {
  ...space.propTypes,
  ...width.propTypes,
  ...flex.propTypes,
  ...order.propTypes,
  ...alignSelf.propTypes,
  ...position.propTypes,
};

export default Box;



// WEBPACK FOOTER //
// ../shop_main/components/Box/index.js